




































































































































import { Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';

import basketService from '@/project/basket/basket.service';
import clearBasketOverlayService from '@/project/modals/overlays/ClearBasketOverlay.service';
import authService from '@/core/auth/auth.service';
import permissionService from '@/project/auth/permission.service';

import { BasketQuoteViewObject, BasketViewModel, ItemIdWithCount, LineItemViewObject } from '@/types/apiServerContract';
import BasketLineItem from './BasketLineItem.vue';
import PageToaster from '@/project/ui-components/PageToaster.vue';
import BasketPageTracker from '@/project/tracking/gtm/BasketPageTracker.vue';
import { PageName } from '@/router/routes/constants';
import OrderSummary from '@/project/ui-components/order/OrderSummary.vue';
import SpinnerOverlay from '@/project/spinners/SpinnerOverlay.vue';
import BasketQuote from './BasketQuote.vue';
import addMultipleItemsToBasketOverlayService from '@/project/modals/overlays/AddMultipleItemsToBasketOverlay.service';
import AdnuntiusBasketBannerBlock from '@/project/app/blocks/AdnuntiusBasketBannerBlock.vue';
import BasketFavorite from '@/project/app/client-pages/basket-page/BasketFavorite.vue';
import scrollService from '@/core/scroll/scroll.service';
import { ValidationObserver } from 'vee-validate';
import Api from '@/project/http/Api.service';
import tokenService from '@/core/auth/token.service';
import sessionService from '@/project/session/session.service';
import GTMBasics from '@/project/tracking/gtm/GTM.basics';

@Component({
    components: {
        BasketPageTracker,
        BasketLineItem,
        PageToaster,
        OrderSummary,
        SpinnerOverlay,
        BasketQuote,
        AdnuntiusBasketBannerBlock,
        BasketFavorite
    }
})

export default class BasketPage extends Vue {
    private priceNotAvailable: boolean = false;
    private invalidOrNotFoundItems: ItemIdWithCount[] = [];

    $refs!: {
        observerRef: InstanceType<typeof ValidationObserver>,
        basketPageTracker: BasketPageTracker

    }

    private get isBasketInitialized() {
        return basketService.isBasketLoaded;
    }

    private clearBasket() {
        clearBasketOverlayService.show();
    }

    get showFavorite(): boolean {
        return this.lineItems?.length > 0 && permissionService.canPunchout() === false;
    }

    private get checkoutPage() {
        return PageName.CHECKOUT;
    }

    private async gotoNextStep() {
        if (this.isPunchout) {
            this.trackNextStep();
            const punchoutForm = await Api.oci.getPunchoutForm();
            const domElement = document.createElement('div');
            domElement.innerHTML = punchoutForm;
            document.body.appendChild(domElement);
            const domForm = domElement.querySelector('form');
            if (domForm) {
                domForm.submit();
            }
        } else {
            await this.$router.push({ name: this.checkoutPage });
        }
    }

    private async trackNextStep() {
        GTMBasics.pushToDataLayer({
            event: 'punchout_complete'
        });
        const userData = tokenService.getUserData(true);
        const measurementId = 'G-PZXST3BTL2';
        const apiSecret = '7L6LYKfjSJuI_ByfMx4hDA';

        // Hit configuration
        const debug = true;
        // In a normal web context, the client id consists of two random 10 digit numbers joined by a dot,
        // and is stored in a cookie and is used to recognise a browser.
        // Is there something similar we can use for punch out contexts?
        const clientId = sessionService.getLocalStorageKey();
        // Constant for the duration of the session (i.e. deleted/reset if session is closed) - set to the timestamp (in seconds) for the first hit
        // const sessionId = '1234567890';
        const sessionId = sessionService.getSessionKey();
        // Current user's contact key
        const contactKey = userData?.contactKey || '';
        // Current user's hashed contact key
        const userId = userData?.userId || '';
        const endpoint = (debug === true) ? '/debug/mp/collect' : '/mp/collect';

        // Hit #1 - tracking that punch out context has opened and session started
        const data = {
            client_id: clientId, // Usua
            timestamp_micros: Date.now() * 1000, // Event timestamp in microseconds
            user_id: userData?.contactHash || '', // DK-BASTRUPVEJ-30', // Replace with user's actual contact key hash
            events: [{
                name: 'session_started',
                params: {
                    shop_context: this.isPunchout ? 'punchout' : 'webshop',
                    crm_id: userId,
                    contact_key: contactKey,
                    engagement_time_msec: '1',
                    session_id: sessionId,
                    debug_mode: 1
                }
            }]
        };

        // Send payload
        // Will return a validation message if debug = true; will dispatch to GA4 if debug = false
        return fetch(`https://www.google-analytics.com${endpoint}?measurement_id=${measurementId}&api_secret=${apiSecret}`, {
            method: 'POST',
            body: JSON.stringify(data)
        });
    }

    private async addMultipleItems() {
        const notFoundItems = await addMultipleItemsToBasketOverlayService.show();
        this.invalidOrNotFoundItems = notFoundItems ?? [];
    }

    private get isPunchout(): boolean {
        return permissionService.canPunchout();
    }

    private get basket(): BasketViewModel | null {
        return basketService.basketWithCommittedLineItems;
    }

    private get lineItems(): LineItemViewObject[] {
        return this.basket?.lineItems ?? [];
    }

    private get quotes(): BasketQuoteViewObject[] {
        return this.basket?.quotes ?? [];
    }

    private get hasItemsInbasket() {
        return this.lineItems.length > 0 || this.quotes.length > 0;
    }

    get isUserLoggedIn(): boolean {
        return authService.isLoggedIn();
    }

    private async created() {
        await basketService.recalcBasket();
    }

    private isEqual(a: any, b: any): boolean {
        return JSON.stringify(a) === JSON.stringify(b);
    }

    private scrollToFirstError() {
        this.$refs.observerRef.validate().then(() => {
            const errorChild = this.$refs.observerRef.$children.length && (this.$refs.observerRef.$children[0] as InstanceType<typeof ValidationObserver>);
            if (errorChild) {
                const firstErrorFieldName = Object.keys(errorChild.errors).find((item) => {
                    return errorChild.errors[item].length > 0 ? item : false;
                });

                const firstField = document.querySelector(`[name="${firstErrorFieldName}"]`);
                if (firstField) {
                    scrollService.scrollToElement(((firstField.parentElement) || firstField) as HTMLElement, -100);
                }
            }
        });
    }
}
